import React from 'react';

import { UbiArticlePage } from 'utils/ubi/pages/useUbiArticle';

import useIsHelpfulAnswer, { IsHelpfulAnswerEnum } from '../../hooks/useIsHelpfulAnswer';
import useSubmitReason from '../../hooks/useSubmitReason';
import useTrackMessageUsLink from '../../hooks/useTrackMessageUsLink';

import IsHelpfulPoll from './IsHelpfulPoll';
import ReasonPoll from './ReasonPoll';
import ThanksDialog from './ThanksDialog';

interface FeedbackContentProps {
  ubi: UbiArticlePage;
  articleIdentifier: string;
  onClose: () => void;
}

const FeedbackContent = ({ ubi, articleIdentifier, onClose }: FeedbackContentProps) => {
  // feedback control
  const { isHelpfulAnswered, answerIfIsHelpful } = useIsHelpfulAnswer({ ubi, articleIdentifier });
  const { isSubmittedReason, submitReason } = useSubmitReason({ ubi, articleIdentifier });
  const { trackMessageUsLink } = useTrackMessageUsLink({ ubi, articleIdentifier });

  if (isHelpfulAnswered === IsHelpfulAnswerEnum.yes || isSubmittedReason) {
    return <ThanksDialog onClose={onClose} answered={isHelpfulAnswered} trackMessageUsLink={trackMessageUsLink} />;
  }

  if (isHelpfulAnswered === IsHelpfulAnswerEnum.no) {
    return (
      <ReasonPoll
        onCancelClick={onClose}
        onSubmit={reason => {
          submitReason(reason);
        }}
      />
    );
  }

  return (
    <IsHelpfulPoll
      onYesClick={() => answerIfIsHelpful(IsHelpfulAnswerEnum.yes)}
      onNoClick={() => answerIfIsHelpful(IsHelpfulAnswerEnum.no)}
    />
  );
};

export default FeedbackContent;
